import React from 'react';

import {BlockSkeleton, TextSkeleton} from '@udemy/react-reveal-components';

import styles from './cart-skeleton.module.less';

export const CartSkeleton = () => (
    <div className={styles['cart-skeleton']}>
        <div className={styles['list-pane']}>
            {[1, 2, 3].map((i) => (
                <div key={i} className={styles['course-item']}>
                    <BlockSkeleton className={styles['course-thumbnail']} />
                    <TextSkeleton lineCountPerParagraph={3} className={styles['course-text']} />
                </div>
            ))}
        </div>
        <div className={styles['checkout-pane']}>
            <TextSkeleton lineCountPerParagraph={2} withTitle />
            <BlockSkeleton className={styles['checkout-button']} />
        </div>
    </div>
);
